import { render, staticRenderFns } from "./AgregaDocumentoFormComponent.vue?vue&type=template&id=3dc685f2&scoped=true"
import script from "./AgregaDocumentoFormComponent.vue?vue&type=script&lang=js"
export * from "./AgregaDocumentoFormComponent.vue?vue&type=script&lang=js"
import style0 from "./AgregaDocumentoFormComponent.vue?vue&type=style&index=0&id=3dc685f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc685f2",
  null
  
)

export default component.exports